/**
 * @generated SignedSource<<8d0e97f54960ab9d12f744974c31abb9>>
 * @relayHash c9a30ea890df4b1615d1c6690433bd3e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 837c0712747985ac05f96169108ab86e71463e3868fd4ecaa63215bf735e13ba

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceApprovalExpirationIntervalUnit = "MONTH" | "WEEK" | "YEAR" | "%future added value";
export type ConfluenceApprovalTransitionType = "DIRECTED" | "INITIAL" | "%future added value";
export type ConfluencePrincipalType = "GROUP" | "USER" | "%future added value";
export type ConfluenceReviewerDecisionState = "PENDING_REVIEW" | "REVIEWER_APPROVED" | "REVIEWER_DENIED" | "REVIEW_CANCELED" | "%future added value";
export type ConfluenceWorkflowReviewStatus = "APPROVED" | "CANCELED" | "DENIED" | "PENDING" | "%future added value";
export type ApprovalsContextApprovalsDataQuery$variables = {
  cloudId: string;
  contentId: string;
  contentStatus: string;
  includeApprovalExpirationConfig: boolean;
  includeApprovalsBetaFeatures: boolean;
  otherContentStatus: string;
  spaceKey: string;
  transitionType?: ConfluenceApprovalTransitionType | null;
};
export type ApprovalsContextApprovalsDataQuery$data = {
  readonly confluence_contentApprovalStatuses: ReadonlyArray<{
    readonly allowsReviews: boolean | null;
    readonly displayProperties: {
      readonly color: string | null;
      readonly name: string | null;
    } | null;
    readonly id: string | null;
  } | null> | null;
  readonly confluence_contentApprovalsSiteSettings?: {
    readonly enabled: boolean;
  } | null;
  readonly confluence_contentApprovalsSpaceSettingConfig?: {
    readonly config: {
      readonly approvalExpirationConfig?: {
        readonly changeStatus: {
          readonly expireToContentStateId: string | null;
          readonly isEnabled: boolean;
        };
        readonly interval: {
          readonly unit: ConfluenceApprovalExpirationIntervalUnit;
          readonly value: number;
        } | null;
        readonly isEnabled: boolean;
        readonly restartApproval: boolean;
      };
      readonly disallowFirstPublish: boolean;
      readonly enforcedApprovalReviewerConfig: {
        readonly isEnabled: boolean;
        readonly reviewers: ReadonlyArray<{
          readonly principalId: string;
          readonly principalType: ConfluencePrincipalType;
          readonly user: {
            readonly displayName: string | null;
            readonly id: string | null;
            readonly isActive: boolean | null;
            readonly photos: ReadonlyArray<{
              readonly isPrimary: boolean | null;
              readonly value: string | null;
            } | null> | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }>;
    readonly success: boolean;
  } | null;
  readonly confluence_getActiveWorkflowApplication: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null;
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }>;
    readonly success: boolean;
    readonly workflowApplication: {
      readonly contentId: string | null;
      readonly contentStatus: string | null;
      readonly contentVersion: number | null;
      readonly creator: {
        readonly displayName: string | null;
        readonly id: string | null;
        readonly isActive: boolean | null;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly id: string | null;
      readonly isActive: boolean | null;
      readonly lastModificationDate: {
        readonly value: string;
      } | null;
      readonly modifier: {
        readonly displayName: string | null;
        readonly id: string | null;
        readonly isActive: boolean | null;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly workflowId: string | null;
      readonly workflowStatusId: string | null;
    } | null;
    readonly workflowReviewWithDecisions: {
      readonly creationDate: {
        readonly value: string;
      } | null;
      readonly creator: {
        readonly displayName: string | null;
        readonly id: string | null;
        readonly isActive: boolean | null;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly creatorAaid: string | null;
      readonly dueDate?: {
        readonly value: string;
      } | null;
      readonly expiryDate?: {
        readonly value: string;
      } | null;
      readonly id: string;
      readonly reviewComment: string | null;
      readonly reviewLastModified: {
        readonly value: string;
      } | null;
      readonly reviewStatus: ConfluenceWorkflowReviewStatus;
      readonly reviewerDecisions: ReadonlyArray<{
        readonly comment: string | null;
        readonly decisionId: string | null;
        readonly lastModifiedDate: {
          readonly value: string;
        } | null;
        readonly principalId: string;
        readonly principalType: ConfluencePrincipalType;
        readonly required: boolean | null;
        readonly reviewerDecisionStatus: ConfluenceReviewerDecisionState | null;
        readonly reviewerId: string | null;
        readonly user: {
          readonly displayName: string | null;
          readonly id: string | null;
          readonly isActive: boolean | null;
          readonly photos: ReadonlyArray<{
            readonly isPrimary: boolean | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
      } | null>;
    } | null;
  } | null;
  readonly confluence_getActiveWorkflowApplicationForOtherStatus: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null;
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }>;
    readonly success: boolean;
    readonly workflowReviewWithDecisions: {
      readonly id: string;
      readonly reviewStatus: ConfluenceWorkflowReviewStatus;
    } | null;
  } | null;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly status: string | null;
      readonly version: {
        readonly number: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly space: {
    readonly id: string | null;
    readonly settings?: {
      readonly contentStateSettings: {
        readonly spaceContentStates: ReadonlyArray<{
          readonly id: string | null;
          readonly name: string;
        } | null> | null;
      };
    } | null;
    readonly spaceTypeSettings: {
      readonly enabledFeatures: {
        readonly isContentApprovalsEnabled: boolean | null;
      };
    };
  } | null;
};
export type ApprovalsContextApprovalsDataQuery = {
  response: ApprovalsContextApprovalsDataQuery$data;
  variables: ApprovalsContextApprovalsDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatus"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeApprovalExpirationConfig"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeApprovalsBetaFeatures"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "otherContentStatus"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "transitionType"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "args": [
    {
      "kind": "Variable",
      "name": "key",
      "variableName": "spaceKey"
    }
  ],
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "concreteType": "SpaceTypeSettings",
      "kind": "LinkedField",
      "name": "spaceTypeSettings",
      "plural": false,
      "selections": [
        {
          "concreteType": "EnabledFeatures",
          "kind": "LinkedField",
          "name": "enabledFeatures",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isContentApprovalsEnabled"
            }
          ]
        }
      ]
    },
    {
      "condition": "includeApprovalExpirationConfig",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "SpaceSettings",
          "kind": "LinkedField",
          "name": "settings",
          "plural": false,
          "selections": [
            {
              "concreteType": "ContentStateSettings",
              "kind": "LinkedField",
              "name": "contentStateSettings",
              "plural": false,
              "selections": [
                {
                  "concreteType": "ContentState",
                  "kind": "LinkedField",
                  "name": "spaceContentStates",
                  "plural": true,
                  "selections": [
                    (v8/*: any*/),
                    (v9/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v11 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v12 = {
  "kind": "ScalarField",
  "name": "success"
},
v13 = {
  "kind": "ScalarField",
  "name": "message"
},
v14 = {
  "kind": "ScalarField",
  "name": "isEnabled"
},
v15 = {
  "kind": "ScalarField",
  "name": "value"
},
v16 = {
  "kind": "ScalarField",
  "name": "principalType"
},
v17 = {
  "kind": "ScalarField",
  "name": "principalId"
},
v18 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v19 = {
  "kind": "ScalarField",
  "name": "isActive"
},
v20 = {
  "kind": "ScalarField",
  "name": "isPrimary"
},
v21 = [
  (v8/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  {
    "concreteType": "AtlassianUserPhoto",
    "kind": "LinkedField",
    "name": "photos",
    "plural": true,
    "selections": [
      (v15/*: any*/),
      (v20/*: any*/)
    ]
  }
],
v22 = {
  "condition": "includeApprovalsBetaFeatures",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        (v11/*: any*/)
      ],
      "concreteType": "ConfluenceContentApprovalsSiteSettings",
      "kind": "LinkedField",
      "name": "confluence_contentApprovalsSiteSettings",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "enabled"
        }
      ]
    },
    {
      "args": [
        (v11/*: any*/),
        {
          "kind": "Literal",
          "name": "filterSelf",
          "value": false
        },
        {
          "kind": "Variable",
          "name": "spaceKey",
          "variableName": "spaceKey"
        }
      ],
      "concreteType": "ConfluenceContentApprovalsSpaceSettingConfigPayload",
      "kind": "LinkedField",
      "name": "confluence_contentApprovalsSpaceSettingConfig",
      "plural": false,
      "selections": [
        (v12/*: any*/),
        {
          "concreteType": "MutationError",
          "kind": "LinkedField",
          "name": "errors",
          "plural": true,
          "selections": [
            (v13/*: any*/)
          ]
        },
        {
          "concreteType": "ConfluenceContentApprovalsSpaceSettingConfig",
          "kind": "LinkedField",
          "name": "config",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "disallowFirstPublish"
            },
            {
              "condition": "includeApprovalExpirationConfig",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "concreteType": "ConfluenceApprovalExpirationConfig",
                  "kind": "LinkedField",
                  "name": "approvalExpirationConfig",
                  "plural": false,
                  "selections": [
                    (v14/*: any*/),
                    {
                      "concreteType": "ConfluenceApprovalExpirationInterval",
                      "kind": "LinkedField",
                      "name": "interval",
                      "plural": false,
                      "selections": [
                        (v15/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "unit"
                        }
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "name": "restartApproval"
                    },
                    {
                      "concreteType": "ConfluenceApprovalExpirationChangeStatus",
                      "kind": "LinkedField",
                      "name": "changeStatus",
                      "plural": false,
                      "selections": [
                        (v14/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "expireToContentStateId"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "concreteType": "ConfluenceApprovalReviewerConfig",
              "kind": "LinkedField",
              "name": "enforcedApprovalReviewerConfig",
              "plural": false,
              "selections": [
                (v14/*: any*/),
                {
                  "concreteType": "ConfluenceSpaceApprovalReviewerEntry",
                  "kind": "LinkedField",
                  "name": "reviewers",
                  "plural": true,
                  "selections": [
                    (v16/*: any*/),
                    (v17/*: any*/),
                    {
                      "concreteType": "AtlassianUser",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": (v21/*: any*/)
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v23 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v24 = {
  "kind": "ScalarField",
  "name": "status"
},
v25 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "number"
    }
  ]
},
v26 = {
  "args": [
    (v11/*: any*/),
    {
      "kind": "Variable",
      "name": "transitionType",
      "variableName": "transitionType"
    }
  ],
  "concreteType": "ConfluenceApprovalsWorkflowStatus",
  "kind": "LinkedField",
  "name": "confluence_contentApprovalStatuses",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "allowsReviews"
    },
    {
      "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
      "kind": "LinkedField",
      "name": "displayProperties",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        {
          "kind": "ScalarField",
          "name": "color"
        }
      ]
    }
  ]
},
v27 = {
  "kind": "Variable",
  "name": "contentId",
  "variableName": "contentId"
},
v28 = {
  "kind": "Literal",
  "name": "fetchWorkflowReview",
  "value": true
},
v29 = {
  "kind": "Literal",
  "name": "workflowId",
  "value": "1"
},
v30 = [
  (v11/*: any*/),
  (v27/*: any*/),
  {
    "kind": "Variable",
    "name": "contentStatus",
    "variableName": "otherContentStatus"
  },
  (v28/*: any*/),
  (v29/*: any*/)
],
v31 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v32 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v33 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    (v13/*: any*/),
    {
      "kind": "LinkedField",
      "name": "extensions",
      "plural": false,
      "selections": [
        (v31/*: any*/),
        (v32/*: any*/)
      ]
    }
  ]
},
v34 = {
  "kind": "ScalarField",
  "name": "reviewStatus"
},
v35 = {
  "concreteType": "ConfluenceWorkflowReviewWithDecisions",
  "kind": "LinkedField",
  "name": "workflowReviewWithDecisions",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v34/*: any*/)
  ]
},
v36 = [
  (v11/*: any*/),
  (v27/*: any*/),
  {
    "kind": "Variable",
    "name": "contentStatus",
    "variableName": "contentStatus"
  },
  {
    "kind": "Variable",
    "name": "fetchExpiryDate",
    "variableName": "includeApprovalExpirationConfig"
  },
  (v28/*: any*/),
  (v29/*: any*/)
],
v37 = {
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v21/*: any*/)
},
v38 = [
  (v15/*: any*/)
],
v39 = {
  "concreteType": "ConfluenceWorkflowApplicationDetails",
  "kind": "LinkedField",
  "name": "workflowApplication",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "workflowId"
    },
    {
      "kind": "ScalarField",
      "name": "contentId"
    },
    {
      "kind": "ScalarField",
      "name": "contentVersion"
    },
    {
      "kind": "ScalarField",
      "name": "contentStatus"
    },
    {
      "kind": "ScalarField",
      "name": "workflowStatusId"
    },
    (v19/*: any*/),
    (v37/*: any*/),
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "lastModificationDate",
      "plural": false,
      "selections": (v38/*: any*/)
    },
    {
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "modifier",
      "plural": false,
      "selections": (v21/*: any*/)
    }
  ]
},
v40 = {
  "concreteType": "ConfluenceWorkflowReviewWithDecisions",
  "kind": "LinkedField",
  "name": "workflowReviewWithDecisions",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "creatorAaid"
    },
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "creationDate",
      "plural": false,
      "selections": (v38/*: any*/)
    },
    (v34/*: any*/),
    {
      "kind": "ScalarField",
      "name": "reviewComment"
    },
    {
      "condition": "includeApprovalsBetaFeatures",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "ConfluenceApprovalsDate",
          "kind": "LinkedField",
          "name": "dueDate",
          "plural": false,
          "selections": (v38/*: any*/)
        }
      ]
    },
    {
      "condition": "includeApprovalExpirationConfig",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "ConfluenceApprovalsDate",
          "kind": "LinkedField",
          "name": "expiryDate",
          "plural": false,
          "selections": (v38/*: any*/)
        }
      ]
    },
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "reviewLastModified",
      "plural": false,
      "selections": (v38/*: any*/)
    },
    (v37/*: any*/),
    {
      "concreteType": "ConfluenceReviewerDecisionInfo",
      "kind": "LinkedField",
      "name": "reviewerDecisions",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "decisionId"
        },
        {
          "kind": "ScalarField",
          "name": "reviewerId"
        },
        {
          "kind": "ScalarField",
          "name": "required"
        },
        (v16/*: any*/),
        (v17/*: any*/),
        {
          "kind": "ScalarField",
          "name": "reviewerDecisionStatus"
        },
        {
          "kind": "ScalarField",
          "name": "comment"
        },
        {
          "concreteType": "ConfluenceApprovalsDate",
          "kind": "LinkedField",
          "name": "lastModifiedDate",
          "plural": false,
          "selections": (v38/*: any*/)
        },
        {
          "concreteType": "AtlassianUser",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            {
              "concreteType": "AtlassianUserPhoto",
              "kind": "LinkedField",
              "name": "photos",
              "plural": true,
              "selections": [
                (v20/*: any*/),
                (v15/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v41 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    (v13/*: any*/),
    {
      "kind": "LinkedField",
      "name": "extensions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        (v31/*: any*/),
        (v32/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v8/*: any*/)
          ],
          "type": "BulkMutationErrorExtension"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ApprovalsContextApprovalsDataQuery",
    "selections": [
      (v10/*: any*/),
      (v22/*: any*/),
      {
        "args": (v23/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v24/*: any*/),
              (v25/*: any*/)
            ]
          }
        ]
      },
      (v26/*: any*/),
      {
        "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
        "args": (v30/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v33/*: any*/),
          (v35/*: any*/)
        ]
      },
      {
        "args": (v36/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v33/*: any*/),
          (v39/*: any*/),
          (v40/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ApprovalsContextApprovalsDataQuery",
    "selections": [
      (v10/*: any*/),
      (v22/*: any*/),
      {
        "args": (v23/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v24/*: any*/),
              (v25/*: any*/),
              (v8/*: any*/)
            ]
          }
        ]
      },
      (v26/*: any*/),
      {
        "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
        "args": (v30/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v41/*: any*/),
          (v35/*: any*/)
        ]
      },
      {
        "args": (v36/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v41/*: any*/),
          (v39/*: any*/),
          (v40/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "c9a30ea890df4b1615d1c6690433bd3e",
    "id": "837c0712747985ac05f96169108ab86e71463e3868fd4ecaa63215bf735e13ba",
    "metadata": {},
    "name": "ApprovalsContextApprovalsDataQuery",
    "operationKind": "query",
    "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!,$includeApprovalsBetaFeatures:Boolean!,$includeApprovalExpirationConfig:Boolean!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}},settings@include(if:$includeApprovalExpirationConfig){contentStateSettings{spaceContentStates{id,name}}}},confluence_contentApprovalsSiteSettings(cloudId:$cloudId)@include(if:$includeApprovalsBetaFeatures){enabled}\n  confluence_contentApprovalsSpaceSettingConfig(cloudId:$cloudId,spaceKey:$spaceKey,filterSelf:false)@include(if:$includeApprovalsBetaFeatures){success,errors{message},config{disallowFirstPublish,approvalExpirationConfig@include(if:$includeApprovalExpirationConfig){isEnabled,interval{value,unit},restartApproval,changeStatus{isEnabled,expireToContentStateId}},enforcedApprovalReviewerConfig{isEnabled,reviewers{principalType,principalId,user{id,displayName,isActive,photos{value,isPrimary}}}}}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true,fetchExpiryDate:$includeApprovalExpirationConfig){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,dueDate@include(if:$includeApprovalsBetaFeatures){value},expiryDate@include(if:$includeApprovalExpirationConfig){value},reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
  }
};
})();

(node as any).hash = "f86c7af86f80a82bcaa44eb094b605cc";

export default node;
